// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f38ae7c7","455":"433b9e98","977":"449f044f"}[chunkId] + ".chunk.js";
};